<template>
  <div :class="`px-2 py-2 bg-white border-white rounded-tl-lg rounded-bl-lg flex items-center gap-4 select-none w-full  ${customStyle}`">
    <vs-icon
      color="primary"
      :class="`w-6 rounded-md bg-transparent ${isFeatureAlreadySelected ? '' : 'drag-handle cursor-move'}`"
      :icon="'menu'"
    />
    <div
      v-if="onGroupAdd && !menu.is_feature && typeof menu.id !== 'string'"
      class="p-1 w-8 h-8 self-center flex items-center justify-center bg-secondary rounded cursor-pointer"
      @click="onGroupAdd()"
    >
      <vs-icon
        icon="add_circle_outline"
        color="#fff"
        size="22px"
      />
    </div>
    <div
      v-if="isFeatureAlreadySelected"
      class="flex items-center justify-center h-full"
    >
      <vs-icon
        icon="check_circle"
        color="#2BAC47"
        size="small"
      />
    </div>
    <div v-if="onGroupAdd && menu.icon && !isAvailableMenu">
      <img
        :src="menuIconSrc"
        alt="menu"
        class="w-8 h-auto object-contain"
      >
    </div>
    <div
      v-if="menu.isEditing && !isAvailableMenu"
      class="select-none w-full flex items-center gap-2"
    >
      <div v-if="onGroupAdd">
        <input
          type="file"
          id="fileInput"
          ref="fileInput"
          class="hidden"
          accept="image/*"
          @change="onUpload($event, menu.id)"
        >
        <div
          :class="`flex items-center justify-center icon-transparent-bg ${isProcessing ? 'cursor-not-allowed animate-bounce opacity-50' : ''}`"
          @click="isProcessing ? null : $refs.fileInput.click()"
        >
          <img
            :src="require('@/assets/shipo-icon-edit-upload.svg')"
            class="w-6"
            alt="upload"
          >
        </div>
      </div>
      <vs-input
        class="border rounded-lg border-primary w-full"
        v-model="menuName"
        placeholder="Enter name"
      />
      <div
        class="flex items-center justify-center icon-transparent-bg complete"
        @click="onLocalChangeName()"
      >
        <img
          :src="require('@/assets/shipo-icon-check-circle.svg')"
          alt="check"
        >
      </div>
      <div
        class="flex items-center justify-center icon-transparent-bg delete"
        @click="onLocalCancel()"
      >
        <img
          :src="require('@/assets/shipo-icon-close-circle.svg')"
          alt="close"
        >
      </div>
    </div>

    <p
      v-if="!menu.isEditing || isAvailableMenu"
      v-html="highlightedText"
    />
    <div
      v-if="!menu.isEditing || isAvailableMenu"
      class="flex gap-2 ml-auto"
    >
      <div v-if="onUpload">
        <input
          type="file"
          id="fileInput"
          ref="fileInput"
          class="hidden"
          accept="image/*"
          @change="onUpload($event, menu.id)"
        >
        <div
          :class="`flex items-center justify-center icon-transparent-bg ${isProcessing ? 'cursor-not-allowed animate-bounce opacity-50' : ''}`"
          @click="isProcessing ? null : $refs.fileInput.click()"
        >
          <img
            :src="require('@/assets/shipo-icon-edit-upload.svg')"
            class="w-6"
            alt="upload"
          >
        </div>
      </div>

      <div
        v-if="onEdit && !menu.is_restricted"
        class="flex items-center justify-center icon-transparent-bg"
        @click="onEdit()"
      >
        <img
          :src="require('@/assets/shipo-icon-edit.svg')"
          alt="edit"
        >
      </div>
      <div
        v-if="onRedo && !menu.is_restricted"
        class="w-8 h-8 bg-primary flex items-center justify-center rounded-lg cursor-pointer"
        @click="onRedo()"
      >
        <img
          :src="require('@/assets/shipo-icon-redo.svg')"
          alt="redo"
        >
      </div>
      <div
        v-if="onDelete && !menu.is_restricted"
        class="flex items-center justify-center icon-transparent-bg"
        @click="onDelete()"
      >
        <img
          :src="require('@/assets/shipo-icon-delete.svg')"
          alt="delete"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { decode } from 'html-entities'
import sanitizeHtml from 'sanitize-html'
import { mapGetters } from 'vuex'

export default {
  props: {
    menu: {
      type: Object,
      default: () => {}
    },
    onGroupAdd: {
      type: Function,
      default: null
    },
    onDelete: {
      type: Function,
      default: null
    },
    onRedo: {
      type: Function,
      default: null
    },
    onEdit: {
      type: Function,
      default: null
    },
    onUpload: {
      type: Function,
      default: null
    },
    onCancelEdit: {
      type: Function,
      default: null
    },
    onSaveEdit: {
      type: Function,
      default: null
    },
    customStyle: {
      type: String,
      default: ''
    },
    isAvailableMenu: {
      type: Boolean,
      default: false
    },
    isFeatureAlreadySelected: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: ''
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    onChangeName: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      menuName: this.sanitizeName(this.menu.name)
    }
  },
  computed: {
    ...mapGetters({
      menuIcons: 'Auth/menuIcons'
    }),
    menuIconSrc() {
      const icon = this.menu.icon
      if (icon && icon.downloadUrl) {
        return this.menuIcons[`${this.menu.id}`]?.src || icon.downloadUrl
      }
      return require('@/assets/shipo-menu-home.svg')
    },
    highlightedText() {
      if (!this.search) return this.menuName

      const escaped = this.search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const regex = new RegExp(escaped, 'gi')

      return this.menuName.replace(regex, match => `<mark>${match}</mark>`)
    }
  },
  watch: {
    menu: {
      handler(newVal) {
        this.menuName = this.sanitizeName(newVal.name)
      },
      deep: true
    }
  },
  methods: {
    sanitizeName(name) {
      return decode(sanitizeHtml(name || '', {
        allowedTags: [],
        allowedAttributes: {}
      }))
    },
    onLocalCancel() {
      this.menuName = this.sanitizeName(this.menu.name)
      if (this.onCancelEdit) {
        this.onCancelEdit()
      }
    },
    onLocalChangeName() {
      if (this.onChangeName) {
        this.onChangeName(this.sanitizeName(this.menuName))
      }
    }
  }
}
</script>
